const ContactApi = [
    {
        image:"",
        name:"Our Address",
        description:"PSD Building, 2 AlBhar St. Loskia sripur, Jamukara",
    },
    {
        image:"",
        name:"Our Phone",
        description:"House 77, Model Town Depalpur",
    },
    {
        image:"",
        name:"Our Email",
        description:"Blankslate, New Garden Town Lahore",
    },
]

export default ContactApi;